module.exports = __webpack_public_path__ + "assets/img/affdbd7c1bde41a84f8beda7a0587602.svg";